import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/** Settings holds organization tabs only (the personal ones moved to /profile); today every one of them is the system administrator's. */
export const hasOrganizationSettings = (auth: Pick<AuthService, 'hasRole'>): boolean => auth.hasRole('SystemAdmin');

/** The tabs Settings used to have for everyone; an old link to one of them lands on the profile page. */
const MOVED_TABS: readonly string[] = ['account', 'preferences'];

/** Old /settings?tab=account|preferences links, and Settings for a user with no organization tab, go to /profile. */
export const settingsGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const tab = route.queryParamMap.get('tab');
  if (!hasOrganizationSettings(auth) || (tab !== null && MOVED_TABS.includes(tab))) {
    return router.createUrlTree(['/profile']);
  }
  return true;
};
